import styled from 'styled-components';

export const FinancialListWrap = styled.div`
    display: block;
    width: 100%;
    overflow: auto;
`;
